import {GoalAudienceIcon} from 'shells/icon/svg/goal-audience-icon';
// @ts-expect-error - imported from .js/.jsx file
import {GoalClickIcon} from 'shells/icon/svg/goal-click-icon';
// @ts-expect-error - imported from .js/.jsx file
import {GoalLeadClosedIcon} from 'shells/icon/svg/goal-lead-closed-icon';
// @ts-expect-error - imported from .js/.jsx file
import {GoalLeadCreatedIcon} from 'shells/icon/svg/goal-lead-created-icon';
import {GoalLeadStageIcon} from 'shells/icon/svg/goal-lead-stage-icon';
// @ts-expect-error - imported from .js/.jsx file
import {GoalTagIcon} from 'shells/icon/svg/goal-tag-icon';

export type TriggerTypeEnum =
    | 'ADD_TAG'
    | 'LEAD_CREATED'
    | 'LEAD_STAGE_ENTERED'
    | 'LEAD_CLOSED'
    | 'ADD_TO_AUDIENCE';

export type TriggerTypeValue = {
    value: TriggerTypeEnum;
    label: string;
    sublabel: string;
    icon: React.ComponentType<any>;
};

export const smsTriggerTypeValues: TriggerTypeValue[] = [
    {
        value: 'ADD_TAG',
        label: 'Tag is added to a person',
        sublabel: 'Select a tag',
        icon: GoalTagIcon,
    },
    {
        value: 'LEAD_CREATED',
        label: 'Lead is created',
        sublabel: 'Select a pipeline',
        icon: GoalLeadCreatedIcon,
    },
    {
        value: 'LEAD_STAGE_ENTERED',
        label: 'Lead stage is entered',
        sublabel: 'Select a pipeline stage',
        icon: GoalLeadStageIcon,
    },
    {
        value: 'LEAD_CLOSED',
        label: 'Lead is closed',
        sublabel: 'Select a closed status',
        icon: GoalLeadClosedIcon,
    },
    {
        value: 'ADD_TO_AUDIENCE',
        label: 'Person is added to an audience',
        sublabel: 'Select an audience',
        icon: GoalAudienceIcon,
    },
];

export const emailMarketingTriggerTypeValues: TriggerTypeValue[] = [...smsTriggerTypeValues];

export type GoalTypeEnum =
    | 'LEAD_CREATED'
    | 'ADD_TAG'
    | 'LEAD_WON'
    | 'LINK_CLICKED'
    | 'ADD_TO_AUDIENCE';

export type GoalTypeValue = {
    value: GoalTypeEnum;
    label: string;
    sublabel: string;
    icon: React.ComponentType<any>;
};

export const smsGoalTypeValues: GoalTypeValue[] = [
    {
        value: 'LEAD_WON',
        label: 'Lead is won',
        sublabel: 'Select a pipeline',
        icon: GoalLeadClosedIcon,
    },
    {
        value: 'ADD_TAG',
        label: 'Tag is added to a person',
        sublabel: 'Select a tag',
        icon: GoalTagIcon,
    },
    {
        value: 'LEAD_CREATED',
        label: 'Lead is created',
        sublabel: 'Select a pipeline',
        icon: GoalLeadCreatedIcon,
    },
];

export const emailMarketingGoalTypeValues: GoalTypeValue[] = [
    ...smsGoalTypeValues,
    {
        value: 'ADD_TO_AUDIENCE',
        label: 'Person is added to an audience',
        sublabel: 'Select an audience',
        icon: GoalAudienceIcon,
    },
    {
        value: 'LINK_CLICKED',
        label: 'Link is clicked',
        sublabel: 'Select a link',
        icon: GoalClickIcon,
    },
];

export type NextStepTypeEnum = 'ADD_TAGS' | 'ADD_AUDIENCES' | 'REMOVE_AUDIENCES';

export type NextStepTypeValue = {
    value: NextStepTypeEnum;
    label: string;
    sublabel: string;
    icon: string;
};

export const nextStepTypeValues = [
    {
        value: 'ADD_TAGS',
        label: 'Add a tag to person',
        sublabel: 'Select a tag',
        icon: GoalTagIcon,
    },
    {
        value: 'ADD_AUDIENCES',
        label: 'Add person to an audience',
        sublabel: 'Select an audience',
        icon: GoalAudienceIcon,
    },
    {
        value: 'REMOVE_AUDIENCES',
        label: 'Remove person from an audience',
        sublabel: 'Select an audience',
        icon: GoalAudienceIcon,
    },
] as const;
